import React from "react"
import sisuLogo from "../../../../design/assests/images/sisu_logo.png"
import sisuLogoDark from "../../../../design/assests/images/sisu_logo_dark.png"
import useThemeContext from "../../../../hooks/contextConsumers/useThemeContext.hook"

const ClientReportTitle = ({ clientName, clientLogo }) => {
  const { theme } = useThemeContext()
  const isDarkTheme = theme === "dark"

  return (
    <div className="flex align-items-center justify-content-between py-1 surface-border">
      <div className="client-report-logo-container">
        <img
          src={isDarkTheme ? sisuLogoDark : sisuLogo}
          alt="SISU"
          className="client-report-logo"
        />
      </div>

      <div className="client-report-title-container">
        <h1 className="client-report-main-title">Reporte de cliente</h1>
        <p className="client-report-client-name">{clientName || "Cliente"}</p>
      </div>

      <div className="client-report-logo-container">
        {clientLogo ?
          <img
            src={clientLogo}
            alt={clientName || "Cliente"}
            className="client-report-logo"
          />
        : <div className="client-report-logo-container" />}
      </div>
    </div>
  )
}

export default ClientReportTitle
